<nz-form-item *ngIf="type && showError && position === 'top'">
  <nz-form-control>
    <nz-alert class="m-b-10" [nzType]="type" [nzMessage]="message" nzShowIcon
              nzCloseable></nz-alert>
  </nz-form-control>
</nz-form-item>

<ng-content></ng-content>

<nz-form-item *ngIf="type && showError && position === 'bottom'">
  <nz-form-control>
    <nz-alert class="m-b-10" [nzType]="type" [nzMessage]="message" nzShowIcon
              nzCloseable></nz-alert>
  </nz-form-control>
</nz-form-item>
